import { render, staticRenderFns } from "./factorServices.vue?vue&type=template&id=2165ce1e&scoped=true&"
import script from "./factorServices.vue?vue&type=script&lang=js&"
export * from "./factorServices.vue?vue&type=script&lang=js&"
import style0 from "./factorServices.vue?vue&type=style&index=0&id=2165ce1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2165ce1e",
  null
  
)

export default component.exports